import { useRef, useState } from "react";
import FilterChips from "../filters/FilterChips";
import { TOOLBAR_BUTTON } from "../table/styles";
import { useDismiss } from "../table/useDismiss";
import { DELIVERY_LABELS } from "./productsColumns";

export const DELIVERY_OPTIONS = [
    { key: "", label: "Todas" },
    { key: "presencial", label: DELIVERY_LABELS.presencial },
    { key: "correios", label: DELIVERY_LABELS.correios },
];

/** Rótulo do botão a partir do filtro atual da coluna Entrega (e da Loja, quando presencial). */
export const deliveryButtonLabel = (deliveryValue, storeValue) => {
    if (!deliveryValue?.length) return "Entrega: Todas";
    const names = deliveryValue.map((key) => DELIVERY_LABELS[key] ?? key).join(", ");
    const isPresencial = deliveryValue.length === 1 && deliveryValue[0] === "presencial";
    return isPresencial && storeValue ? `Entrega: ${names} · ${storeValue}` : `Entrega: ${names}`;
};

/**
 * Botão-menu compacto do filtro de Entrega. Escreve nas colunas Entrega e Loja
 * pelos callbacks (o estado continua único, em `columnFilters`).
 */
const DeliveryMenu = ({ deliveryValue, storeValue, stores, onDelivery, onStore }) => {
    const [open, setOpen] = useState(false);
    const buttonRef = useRef(null);
    const panelRef = useRef(null);
    useDismiss(open, [buttonRef, panelRef], () => setOpen(false));

    const deliveryKey = !deliveryValue?.length ? "" : deliveryValue.length === 1 ? deliveryValue[0] : null;
    const choose = (option) => {
        onDelivery(option);
        // Presencial mantém o popover aberto para escolher a Loja.
        if (option.key !== "presencial") setOpen(false);
    };

    return (
        <div className="relative">
            <button ref={buttonRef} type="button" className={TOOLBAR_BUTTON} aria-haspopup="dialog" aria-expanded={open} onClick={() => setOpen((value) => !value)}>
                {deliveryButtonLabel(deliveryValue, storeValue)} <span aria-hidden="true">▾</span>
            </button>
            {open ? (
                <div ref={panelRef} role="dialog" aria-label="Filtro de entrega" className="absolute right-0 z-20 mt-1 flex w-60 flex-col gap-2 rounded border border-primary/40 bg-mgs-elevated p-2 text-left text-sm text-laranjinha shadow-lg">
                    <FilterChips ariaLabel="Opções de entrega" options={DELIVERY_OPTIONS} selectedKey={deliveryKey} onSelect={choose} />
                    {deliveryKey === "presencial" ? (
                        <label className="flex items-center gap-1 text-xs text-laranjinha/80">
                            Loja:
                            <select className="min-w-0 flex-1 rounded border border-primary/40 bg-mgs-surface px-1 py-0.5 text-laranjinha" value={storeValue} onChange={(event) => onStore(event.target.value)} disabled={!stores.length}>
                                <option value="">Todas</option>
                                {stores.map((store) => (
                                    <option key={store._id} value={store.name}>{store.name}</option>
                                ))}
                            </select>
                        </label>
                    ) : null}
                </div>
            ) : null}
        </div>
    );
};

export default DeliveryMenu;
